<template>
    <div class="box-container" v-if="data.name">
        <div class="preview flex justify-between gap-4">
            <div class="w-full">
                <p class="text-[14px] !font-[500] mb-4">{{ data.name || "n/a" }}</p>
                <div class="text-xs !font-[400] mb-[10px]" v-html="getSanitizeHTML(data.text)"></div>
                <div class="grid grid-cols-2 gap-2" style="width: fit-content">
                    <template v-for="(button, index) in data.buttons" :key="index">
                        <div>
                            <AppButton variant="gray" :btn-text="button.buttonText" attrs="disabled" />
                        </div>
                    </template>
                </div>
            </div>
            <fa
                :icon="['fal', 'times']"
                class="cursor-pointer !text-[14px] !font-[300] !leading-normal"
                @click="emits('togglePreview')"
            />
        </div>
    </div>
</template>
<script setup>
import AppButton from "@/components/appComponents/AppButton.vue";
import { getSanitizeHTML } from "@/utils/markdown";
const props = defineProps({
    data: {
        type: Object,
        default: {},
    },
    hasSendButton: {
        type: Boolean,
        default: true,
    },
});
const emits = defineEmits(["togglePreview"]);
</script>

<style>
.preview {
    @apply bg-white dark:bg-dm-whitebg dark:border-black-900;
    padding: 16px;
    border-radius: 8px;
}
.options {
    align-self: flex-end;
}
</style>
